// @flow

import React from 'react';
import type { Node } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import withErrorBoundary from '../withErrorBoundary';
import { rewriteUrl } from '../../helpers';

export type Props = {
  href: string,
  children: Node,
  preventScrollTop?: boolean,
  className?: ?string,
  title?: string,
  onClick?: ?Function,
  /**
   * this prop is used to force an anchor tag (force reloads)
   * this was implemented for the beta site to enforce some urls to the old site.
   */
  useAnchor?: boolean,
};

const isExternal = (url: string) => /^[a-z][a-z0-9+.-]*:/.test(url);
const isUpload = (url: string) => url.includes('/app/uploads/');

const Link = ({
  href,
  children,
  preventScrollTop,
  className,
  title,
  onClick,
  useAnchor,
}: Props) => {
  const url = rewriteUrl(href);
  if (!useAnchor && (!isExternal(url) && !isUpload(url))) {
    return (
      <ReactRouterLink
        to={{
          pathname: url,
          state: {
            preventScrollTop,
          },
        }}
        className={className || ''}
        title={title}
        onClick={onClick}
      >
        {children}
      </ReactRouterLink>
    );
  }
  return (
    <a
      href={href}
      className={className}
      title={title}
      onClick={onClick}
    >
      {children}
    </a>
  );
};

Link.defaultProps = {
  className: '',
  title: '',
  onClick: null,
  preventScrollTop: false,
  useAnchor: false,
};

export default withErrorBoundary<*, *, Props, *, *>(Link);
